import { API_BASE_URL } from '../api';

async function parseJsonResponse(response) {
  const payload = await response.json().catch(() => ({}));

  if (!response.ok) {
    throw new Error(payload.error || 'Request failed.');
  }

  return payload;
}

export async function login(username, password) {
  const response = await fetch(`${API_BASE_URL}/api/auth/login`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ username, password }),
  });

  return parseJsonResponse(response);
}

export async function changePassword(username, currentPassword, newPassword) {
  const response = await fetch(`${API_BASE_URL}/api/auth/change-password`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ username, currentPassword, newPassword }),
  });

  return parseJsonResponse(response);
}

export async function getLoginInfoMessage() {
  const response = await fetch(`${API_BASE_URL}/api/auth/login-info`);
  const payload = await parseJsonResponse(response);
  return payload.message || '';
}

export async function setLoginInfoMessage(username, message) {
  const response = await fetch(`${API_BASE_URL}/api/auth/login-info`, {
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ username, message }),
  });

  return parseJsonResponse(response);
}